module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_0.03f1111e.png";